import { Injectable } from '@angular/core';

import {
  HttpInterceptor, HttpHandler,
  HttpRequest, HttpResponse
} from '@angular/common/http';

import { finalize, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment.prod';

@Injectable()
export class HttpErrorResponseInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {

    const started = Date.now();
    let ok: string;
    let fail: string;

    // extend server response observable with logging
    return next.handle(req)
      .pipe(
        tap(
          // Succeeds when there is a response; ignore other events
          event => ok = environment.logApiCalls && event instanceof HttpResponse ? 'succeeded' : '',
          // Operation failed; error is an HttpErrorResponse
          error => {
            switch (error.status) {
              case 400:
                this.log400ErrorResponse(error.error);
                //fail = '400 error: ' + this.messenger.toString();
                break;
              case 401:
              case 404:
              case 412:
                break;
              case 500:
              default:
                //this.messenger.add('An unexpected error occurred. Please try again later. (' + error.status + ')');
                fail = error.status + ' error: ' + error.message;
                break;
            }
          }
        ),
        // Log when response observable either completes or errors
        finalize(() => {
          if (fail || environment.logApiCalls) {
            let msg = fail ? fail : ok;
            const elapsed = Date.now() - started;
            const message = `${req.method} "${req.urlWithParams}" ${msg} in ${elapsed} ms.`;
            console.log(message);
          }
        })
      );
  }

  isNonEmptyArrayOfStrings(value: any): boolean {
    return Array.isArray(value) && !!value.length && value.every(item => typeof item === "string");
  }

  log400ErrorResponse(error: any): void {
    if (typeof error === "string") {
      console.log('400 response: ' + error);
    }
    else if (this.isNonEmptyArrayOfStrings(error)) {
      error.forEach((msg: string) => {
        console.log('400 response: ' + msg);
      });
    } else {
      try {
        let errorKeys = Object.keys(error);
        errorKeys.forEach(property => {
          console.log('400 response: ' + property + ': ' + error[property]);
        });
      } catch (e) {
        console.log('400 response: ' + JSON.stringify(error));
      }
    }
  }

}
